import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import siteConfig from "./config/siteConfig";
import productData from "./Datas/productData";

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const titles = {
      "/": `${siteConfig.brandName} | Ocean-minded slow fashion`,
      "/shop": `Shop | ${siteConfig.brandName}`,
      "/about": `Our story | ${siteConfig.brandName}`,
      "/contact": `Contact | ${siteConfig.brandName}`,
      "/cartpage": `Shopping bag | ${siteConfig.brandName}`,
      "/checkout": `Checkout | ${siteConfig.brandName}`,
      "/paysuccess": `Order confirmation | ${siteConfig.brandName}`,
      "/privacy": `Privacy policy | ${siteConfig.brandName}`,
      "/terms": `Terms & conditions | ${siteConfig.brandName}`,
      "/returns": `Returns | ${siteConfig.brandName}`,
      "/shipping": `Shipping | ${siteConfig.brandName}`,
    };
    const productId = location.pathname.match(/^\/shopDetails\/(\d+)$/)?.[1];
    const product = productId ? productData.find((item) => item.id === Number(productId)) : null;
    document.title = product
      ? `${product.name} — ${product.colorName} | ${siteConfig.brandName}`
      : titles[location.pathname] || `${siteConfig.brandName} | Sustainable clothing`;
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <RouteEffects />
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Header />
        <div id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
